import { QueryKey } from "@tanstack/react-query";
import { z } from "zod";

import { createMutationBaseMixin } from "./mixins/base-mutation";
import { createQueryBaseMixin } from "./mixins/base-query";
import { createMutationProtoMixin, createQueryProtoMixin } from "./mixins/protos";
import { MutationDefinitionOptions, QueryDefinitionOptions } from "./types";

export function createQueryRequestDefinition<
  TQueryKey extends QueryKey,
  Path extends string,
  ParamsSchema extends z.ZodTypeAny,
  ResponseSchema extends z.ZodTypeAny,
  TransformedResult extends object = z.infer<ResponseSchema>,
>(
  definitionOptions: QueryDefinitionOptions<
    TQueryKey,
    Path,
    ParamsSchema,
    ResponseSchema,
    TransformedResult
  >
) {
  const base = createQueryBaseMixin(definitionOptions);
  const { withProtos } = createQueryProtoMixin(definitionOptions);

  return { ...base, withProtos };
}

export function createMutationRequestDefinition<
  Path extends string,
  ParamsSchema extends z.ZodTypeAny,
  ResponseSchema extends z.ZodTypeAny,
  TransformedResult extends object = z.infer<ResponseSchema>,
>(
  definitionOptions: MutationDefinitionOptions<
    Path,
    ParamsSchema,
    ResponseSchema,
    TransformedResult
  >
) {
  const base = createMutationBaseMixin(definitionOptions);
  const { withProtos } = createMutationProtoMixin(definitionOptions);

  return { ...base, withProtos };
}
